import * as React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <React.Fragment>
    <path
      d="M9.615 20H7C6.46957 20 5.96086 19.7893 5.58579 19.4142C5.21071 19.0391 5 18.5304 5 18V6C5 5.46957 5.21071 4.96086 5.58579 4.58579C5.96086 4.21071 6.46957 4 7 4H15C15.5304 4 16.0391 4.21071 16.4142 4.58579C16.7893 4.96086 17 5.46957 17 6V14"
      stroke="var(--text-heading)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
      transform="translate(-4, -4) scale(1.3)"
    />
    <path
      d="M9 8H13"
      stroke="var(--text-heading)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
      transform="translate(-4, -4) scale(1.3)"
    />
    <path
      d="M9 12H11"
      stroke="var(--text-heading)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
      transform="translate(-4, -4) scale(1.3)"
    />
    <path
      d="M19.2929 16.293C19.6834 15.9025 20.3164 15.9025 20.707 16.293C21.0975 16.6835 21.0975 17.3166 20.707 17.7071L16.707 21.7071C16.3164 22.0976 15.6834 22.0976 15.2929 21.7071L13.2929 19.7071C12.9024 19.3166 12.9024 18.6835 13.2929 18.293C13.6834 17.9025 14.3164 17.9025 14.707 18.293L15.9999 19.586L19.2929 16.293Z"
      fill="var(--text-heading)"
      transform="translate(-4, -4) scale(1.3)"
    />
  </React.Fragment>,
  'TicketWasPrinted'
)
